import React, { createContext, useContext, useState } from 'react'

const MobileBackContext = createContext({
	customBack: null,
	setCustomBack: () => {}
})

export const MobileBackProvider = ({ children }) => {
	const [customBack, setCustomBack] = useState(null)
	return (
		<MobileBackContext.Provider value={{ customBack, setCustomBack }}>
			{children}
		</MobileBackContext.Provider>
	)
}

export const useMobileBack = () => useContext(MobileBackContext)
